import { render, staticRenderFns } from "./checkReason.vue?vue&type=template&id=790af8ac&scoped=true"
import script from "./checkReason.vue?vue&type=script&lang=js"
export * from "./checkReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790af8ac",
  null
  
)

export default component.exports